"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledComponentsStyleSheetManager = StyledComponentsStyleSheetManager;
/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
// styled-components v6 no longer filters custom styling props automatically.
// Restore that behaviour so existing components do not pass those props to DOM elements.
function StyledComponentsStyleSheetManager({ children, }) {
    return (react_1.default.createElement(styled_components_1.StyleSheetManager, { shouldForwardProp: (prop, element) => typeof element === "string" ? (0, is_prop_valid_1.default)(prop) : true }, children));
}
//# sourceMappingURL=StyledComponentsStyleSheetManager.js.map